module.exports = __webpack_public_path__ + "img/provider_livecasino.cdc84dfc.svg";